var module = angular.module('octopusApp.library');

module.controller('StepTemplatesIndexController', function ($scope, $location, $uibModal, $q, busy, octopusRepository, $filter) {
    var isLoading = $scope.isLoading = busy.create();

    $scope.IsCommunityActionTemplatesEnabled = true;
    $scope.addCustomStepTemplateUrl = "#/library/steptemplates/builtin/";
    $scope.installCommunityStepTempalteUrl = "#/library/steptemplates/community/";
    $scope.communityStepTemplates = [];
    $scope.userStepTemplates = [];

    $scope.resolve = octopusRepository.resolve;
    $scope.resolveLink = $filter('resolveLink');

    var stepTemplatesLoader = octopusRepository.ActionTemplates.search();
    var featuresLoader = octopusRepository.FeaturesConfiguration.get();
    var loaders = [stepTemplatesLoader, featuresLoader];

    isLoading.promise($q.all(loaders).then(function(results) {

        var allStepTemplates = results[0];
        var featureConfig = results[1];
        $scope.IsCommunityActionTemplatesEnabled = featureConfig.IsCommunityActionTemplatesEnabled;

        $scope.userStepTemplates = _.filter(allStepTemplates, function (template) {
            return template.IsInstalled && !template.IsBuiltIn && template.CommunityActionTemplateId == null;
        });

        $scope.communityStepTemplates = _.filter(allStepTemplates, function(template) {
            return !template.IsBuiltIn && template.CommunityActionTemplateId != null;
        });

        var installedStepTemplateId = $location.search().installedStep;
        var installedStepTemplate = _.find($scope.communityStepTemplates, function(template) { return template.Id === installedStepTemplateId; });
        _.extend(installedStepTemplate, {stepInstalledSuccessfully: true});

    }));

    $scope.addCustomStepTemplate = function () {

        $location.path("/library/" + $scope.project.Slug + "/steptemplates");

    };

    $scope.installCommunityStepTemplate = function () {

        $location.path("/library/steptemplates/community/");

    };

    $scope.addImport = function () {
        $uibModal.open({
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/shared/views/import_entity_dialog.html',
            controller: 'ImportEntityDialogController',
            dialogClass: 'modal modal-big',
            resolve: {
                entityType: function () {
                    return 'ActionTemplate';
                },
                doImport: function () {
                    return function (result) {
                        return octopusRepository.ActionTemplates.create(result).then(function (created) {
                            $location.path("/library/steptemplates/" + created.Id);
                        });
                    };
                }
            }
        });
    };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/library/steps/controllers/step_templates_index_controller.js
// module id = 6340508293140867
// module chunks = 1